"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  DismissalSource: () => DismissalSource,
  ModalView: () => ModalView
});
module.exports = __toCommonJS(index_exports);

// src/ModalView.tsx
var import_react_native = require("react-native");

// src/ScrollContextResetter.tsx
var import_virtualized_lists = require("@react-native/virtualized-lists");
var import_ScrollViewContext = __toESM(require("react-native/Libraries/Components/ScrollView/ScrollViewContext"));
var ScrollContextResetter = /* @__PURE__ */ __name(({ children }) => {
  return /* @__PURE__ */ React.createElement(import_virtualized_lists.VirtualizedListContextResetter, null, /* @__PURE__ */ React.createElement(import_ScrollViewContext.default.Provider, {
    value: null
  }, children));
}, "ScrollContextResetter");

// src/integrations/GestureHandlerRootView.tsx
var importGestureHandlerRootView = /* @__PURE__ */ __name(() => {
  const Errors = {
    GestureHandlerRootViewNotFound: new Error("GestureHandlerRootView not found. Please report the issue: https://github.com/paufau/react-native-multiple-modals/issues")
  };
  try {
    const GestureHandlerRootViewComponent = require("react-native-gesture-handler").GestureHandlerRootView;
    if (!GestureHandlerRootViewComponent) {
      throw Errors.GestureHandlerRootViewNotFound;
    }
    return GestureHandlerRootViewComponent;
  } catch (e) {
    if (e === Errors.GestureHandlerRootViewNotFound) {
      console.error(e);
    }
    return ({ children }) => children;
  }
}, "importGestureHandlerRootView");
var GestureHandlerRootView = importGestureHandlerRootView();

// src/newarch/NativeRNTModalView.ts
var import_codegenNativeComponent = __toESM(require("react-native/Libraries/Utilities/codegenNativeComponent"));
var NativeRNTModalView_default = (0, import_codegenNativeComponent.default)("RNTModalView", {
  interfaceOnly: true
});

// src/ModalView.tsx
var DismissalSource = /* @__PURE__ */ function(DismissalSource2) {
  DismissalSource2["BackButton"] = "BackButton";
  DismissalSource2["Backdrop"] = "Backdrop";
  return DismissalSource2;
}({});
var backdropAccessibilityLabel = "Backdrop";
var backdropAccessibilityHint = "Double-tap to close the modal";
var defaultBackdropColor = "rgba(0, 0, 0, 0.3)";
var isIOS = import_react_native.Platform.OS === "ios";
var ModalView = /* @__PURE__ */ __name(({ children, renderBackdrop, onRequestDismiss, contentContainerStyle, statusBar, BackdropPressableComponent = import_react_native.Pressable, backdropColor = defaultBackdropColor, disableDefaultStatusBarIOS = false, animationType = "none", statusBarTranslucent }) => {
  return /* @__PURE__ */ React.createElement(import_react_native.View, null, /* @__PURE__ */ React.createElement(NativeRNTModalView_default, {
    style: styles.container,
    statusBarTranslucent: statusBar?.translucent ?? statusBarTranslucent,
    statusBarIconsStyle: statusBar?.barStyle ?? void 0,
    onPressBackAndroid: /* @__PURE__ */ __name(() => onRequestDismiss?.("BackButton"), "onPressBackAndroid"),
    animationType
  }, /* @__PURE__ */ React.createElement(import_react_native.View, {
    collapsable: false,
    style: styles.flex
  }, isIOS && statusBar && !disableDefaultStatusBarIOS ? /* @__PURE__ */ React.createElement(import_react_native.StatusBar, statusBar) : null, /* @__PURE__ */ React.createElement(GestureHandlerRootView, {
    style: styles.flex
  }, /* @__PURE__ */ React.createElement(import_react_native.View, {
    style: [
      styles.backdropContainer
    ]
  }, /* @__PURE__ */ React.createElement(BackdropPressableComponent, {
    accessibilityLabel: backdropAccessibilityLabel,
    accessibilityHint: backdropAccessibilityHint,
    style: styles.flex,
    onPress: /* @__PURE__ */ __name(() => onRequestDismiss?.("Backdrop"), "onPress")
  }, renderBackdrop ? renderBackdrop() : /* @__PURE__ */ React.createElement(import_react_native.View, {
    style: [
      styles.flex,
      {
        backgroundColor: backdropColor
      }
    ]
  }))), /* @__PURE__ */ React.createElement(ScrollContextResetter, null, /* @__PURE__ */ React.createElement(import_react_native.View, {
    pointerEvents: "box-none",
    style: [
      styles.content,
      contentContainerStyle
    ]
  }, children))))));
}, "ModalView");
var styles = import_react_native.StyleSheet.create({
  container: {
    position: "absolute"
  },
  flex: {
    flex: 1
  },
  content: {
    zIndex: 1,
    flex: 1
  },
  backdropContainer: {
    position: "absolute",
    zIndex: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DismissalSource,
  ModalView
});
